import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "form-label small mb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_auto_textarea = _resolveComponent("auto-textarea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createVNode(_component_localized_text, {
        localizedKey: "Contenuto",
        text: "Contenuto"
      })
    ]),
    _createVNode(_component_auto_textarea, {
      class: "form-control",
      modelValue: _ctx.localValue.text,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.text) = $event))
    }, null, 8, ["modelValue"])
  ]))
}